import { createFileRoute, redirect } from "@tanstack/react-router";
import { useSession } from "@tanstack/react-start/server";
import { betaSessionConfig, type BetaSession } from "@/lib/beta-session";

async function clearBetaSession() {
  const session = await useSession<BetaSession>(betaSessionConfig());
  await session.clear();
}

export const Route = createFileRoute("/logout")({
  head: () => ({
    meta: [
      { title: "Sign out — NexKey.gg" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  server: {
    handlers: {
      GET: async () => {
        await clearBetaSession();
        return new Response(null, {
          status: 302,
          headers: { Location: "/login", "cache-control": "no-store" },
        });
      },
      POST: async () => {
        await clearBetaSession();
        return new Response(null, {
          status: 302,
          headers: { Location: "/login", "cache-control": "no-store" },
        });
      },
    },
  },
  beforeLoad: () => {
    throw redirect({ to: "/login", search: { redirect: "/", error: false } });
  },
  component: () => null,
});
